




import Vue from "vue";
import { mapState, mapActions } from "vuex";
import cloneDeep from "lodash/cloneDeep";

import Execution from "@/components/execute/Execution.vue";

export default Vue.extend({
  props: ["id"],
  computed: mapState({
    execution(state: any) {
      const item = state.executions.find(
        (exec: any) => exec.id === (this as any).id
      );
      return cloneDeep(item);
    }
  }),
  methods: mapActions(["updateExecution"]),
  components: {
    Execution
  }
});
